import Portal from "../../lib/customHooks/usePortal";
import { slugify } from "../../lib/utils";

/*
  Usage notes: showing or hiding the component should be handled by other components,
  based on some state: cancelAction confirmAction should handle both closing the modal
  as well as performing any action required.
*/

export const AlertModal = ({
  modalTitle,
  type = 'alert',
  cancelAction,
  confirmAction,
  children,
  cancelBtnText = 'Cancel',
  confirmBtnText = 'Send'
}) => {
  const id = slugify(modalTitle + '-modal-alert-title');
  const isDanger = type === 'danger';
  const className = `foundry--modal modal--alert foundry--surface ${isDanger ? `surface--error` : ``}`;
  const cancelBtnClass = `modal--cancel-button foundry--button button--outlined button--condensed ${isDanger ? `button--danger` : ``}`;
  const confirmBtnClass = `modal--confirm-button foundry--button button--contained button--condensed ${isDanger ? `button--danger` : ``}`;
  return <Portal className="portal-modal alert-modal">
      <div className="portal-modal--background" />
      <div className={className} role="dialog" aria-labelledby={id}>
        <header className="modal--header">
          {isDanger && <i className="foundry-icon icon--exclamation-triangle modal--icon"></i>}
          <h2 id={id} className="modal--title">
            {modalTitle}
          </h2>
        </header>
        <div className="modal--content">{children}</div>
        <footer className="modal--footer">
          {cancelAction && <button onClick={cancelAction} type="button" className={cancelBtnClass}>
              <span className="button--label">{cancelBtnText}</span>
            </button>}
          <button onClick={confirmAction} type="button" className={confirmBtnClass}>
            <span className="button--label">{confirmBtnText}</span>
          </button>
        </footer>
      </div>
    </Portal>;
};